const kitcut = (text, limit, strong = false) => {
    if(strong){
        if (text.length <= limit) return text;
        text = text.slice(0, limit); 
        while(text.at(-1) === ' '){
            text = text.slice(0, -1);
        }
        return text + "...";
    } else {
        text = text.trim();
        if (text.length <= limit) return text;
        text = text.slice(0, limit); 
        let lastSpace = text.lastIndexOf(" ");
        if (lastSpace > 0) { 
            text = text.substr(0, lastSpace);
        }
        return text + "...";
    }
}
export default kitcut;